var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelemedicina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FDF5EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 40H50.0001V12.5H10.0001V40ZM32.5001 45V50H42.5001V55H17.5001V50H27.5001V45H7.4801C7.15182 44.998 6.82714 44.9313 6.5247 44.8036C6.22225 44.676 5.94797 44.4899 5.71758 44.256C5.48719 44.0221 5.30522 43.7451 5.1821 43.4407C5.05898 43.1364 4.99714 42.8108 5.0001 42.4825V10.0175C5.0001 8.6275 6.1376 7.5 7.4801 7.5H52.5201C53.8901 7.5 55.0001 8.6225 55.0001 10.0175V42.4825C55.0001 43.8725 53.8626 45 52.5201 45H32.5001Z",
    fill: "#115896"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelemedicina);
export default __webpack_public_path__ + "static/media/Telemedicina.23feedd65c842ceeeca55077e58b20bb.svg";
export { ForwardRef as ReactComponent };